export enum DeviceType {
  WEB = 'Web',
  OTHER = 'other',
}
